<div *ngIf="message !== ''; else opportunityInfo">{{ 'overlayDetails.' + message | xTranslate }}</div>
<ng-template #opportunityInfo>
  <div *ngFor="let item of opportunities" class="navigate-opportunities">
    <span (click)="navigate.emit(item)">{{ item.Opportunity_No__c }}</span>
  </div>
</ng-template>
